import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useSoyuzExperiment } from '@spotahome/soyuz/client';

import { DSIcon } from '@spotahome/ui-library/base';

import './PropertyTitle.scss';

const PropertyDescriptionItem = ({ value, text, iconName = '' }) => {
  const isListingSimplificationHeaderVariant =
    useSoyuzExperiment('ListingSimplificationHeaderV2').get('behaviour') ===
    'variant';

  const valueClass = classNames('property-description-item__value', {
    'property-description-item__value--bold':
      !isListingSimplificationHeaderVariant
  });
  return (
    <div className="property-description-item">
      {iconName && (
        <DSIcon name={iconName} className="property-title__icon" size="s" />
      )}
      <span className={valueClass}>{value}</span> {text}
    </div>
  );
};

PropertyDescriptionItem.propTypes = {
  value: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  iconName: PropTypes.string
};

export default PropertyDescriptionItem;
